<!--
 * @Description: 
 * @Date: 2020-09-25 10:48:46
 * @LastEditors: jml
-->
<template>
  <div class="edit-address">
    <div class="title">填写收货信息后，便于后续奖品的发放</div>
    <lAddress :success="success"></lAddress>
  </div>
</template>

<script>
import areaList from './config/area';
import lAddress from './components/address';
export default {
  name: 'editAddress',
  components: { lAddress },
  data() {
    return {};
  },
  computed: {},
  methods: {
    success() {
      console.log('保存成功');
      this.$toast.success('保存成功');
      this.$router.go(-1);
    }
  },
  created() {}
};
</script>

<style lang="less">
.edit-address {
  padding: 1.08rem 0.53rem;
  & > .title {
    font-size: 0.51rem;
    font-weight: bold;
    color: #323235;
    line-height: 1;
    padding-bottom: 1.07rem;
  }
}
</style>